import { render, staticRenderFns } from "./topic-resume-loader.vue?vue&type=template&id=e9a2a0b8&scoped=true&"
import script from "./topic-resume-loader.vue?vue&type=script&lang=js&"
export * from "./topic-resume-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a2a0b8",
  null
  
)

export default component.exports